module.exports = __webpack_public_path__ + "img/ne.6ee212a5.svg";